import { render, staticRenderFns } from "./CursoLista.vue?vue&type=template&id=adc770aa&"
import script from "./CursoLista.vue?vue&type=script&lang=js&"
export * from "./CursoLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports